import { collection, findSelector, member, resource, withAllResults } from "data/helpers/apiv3";
import { GoalParticipant } from "data/records";
import { Map } from "immutable";
import { fulfilled } from "lib/promiseMiddlewareHelpers";

const [api, actions] = resource(GoalParticipant, [
  ["list", collection.get("", ["goalId", "following", "scope", "privacyCode"])],
  member.post("remove"),
  member.post("unremove"),
]);
actions.allParticipants = withAllResults(actions.list);

const selectors = {
  ...findSelector(GoalParticipant),
  byGoalId: (state, goalId) => state.apiv3.goalParticipant.id.filter((gp) => gp.goalId === goalId),
  ranksForGoal: (state, goalId) => state.apiv3.getIn(["goalParticipant", "ranks", goalId], { gpRanks: [] }),
  allForUser: (state, userId) => state.apiv3.goalParticipant.id.filter((gp) => gp.userId === userId),
  forUserByGoal: (state, userId, goalId) =>
    state.apiv3.goalParticipant.id.find((gp) => gp.goalId === goalId && gp.userId === userId),
  byUserIdsAndGoal: (state, userIds, goalId) =>
    state.apiv3.goalParticipant.id.filter((gp) => userIds.includes(gp.userId) && goalId === gp.goalId),
};

const reducers = {
  [fulfilled(actions.list.type)]: (state, action) => {
    // this _should_ only be sent on the initial participants request.
    // let's make sure not to blow it away
    const { goalId } = action.meta;
    if (!state.getIn(["ranks", goalId])) {
      const { gp_ranks: gpRanks, split_index: splitIndex } = action.payload.meta;
      return state.setIn(["ranks", goalId], { gpRanks, splitIndex });
    }
    return state;
  },
};

const initialState = {
  ranks: Map(), // Map(goalId: {gpRanks: [], splitIndex: int})
};

export {
  api as goalParticipantApi,
  actions as goalParticipantActions,
  selectors as goalParticipantSelectors,
  reducers as goalParticipantReducers,
  initialState as goalParticipantInitialState,
};
